import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { setupMetaPixel } from './services/metaPixel';
import pinia from './store';
import './index.css';

const app = createApp(App);
app.use(pinia);
app.use(router);
app.mount('#app');
setupMetaPixel(router);

// Register the minimal (no-cache) service worker so the browser treats the
// portal as an installable PWA. This unlocks the native "Add to Home screen"
// install prompt used when a visitor chooses "Open in browser". The worker
// caches nothing, so there is no staleness risk.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Installability is a progressive enhancement — ignore failures.
    });
  });
}
